// extracted by mini-css-extract-plugin
module.exports = {"activityContainer":"style-module__activityContainer___1x9qA","activity":"style-module__activity___2Lou9","rewatchVideo":"style-module__rewatchVideo___1d_LI"};